<template src="./template.html"></template>

<script>
  import { mapFields } from 'vuex-map-fields'
  import { mapActions, mapGetters, mapState } from 'vuex'

  import CartItem from '../CartItem'
  import CartOverview from '../CartOverview'

  export default {
    components: {
      CartItem,
      CartOverview,
    },
    props: {
      index: Number,
      isTabActive: Boolean,
      invalid: Boolean,
      validated: Boolean,
    },
    data() {
      return {
        disclaimerOpened: false,
        text: window.text,
      }
    },
    computed: {
      ...mapState('auth', [
        'isInit',
        'auth_status',
        'pendingAuth',
      ]),
      ...mapState('summary', [ 'summary' ]),
      ...mapState('settings', [ 'settings' ]),
      ...mapState('cart', [
        'error',
        'min_order_value',
        'disclaimer',
        'isPaymentError',
        'pendingPurchase',
        'cartRequiredFields',
      ]),
      ...mapGetters('summary', [ 'isPending' ]),
      ...mapFields('cart', [
        'agb',
        'create_account',
      ]),
      getCursor() {
        return this.pendingPurchase ? 'wait' : 'pointer'
      },
      isDisabled() {
        return this.pendingPurchase || (this.summary && this.summary.props && this.summary.props.error_message)
      },
      showCreateAccountCheckbox() {
        return !this.pendingAuth && !this.auth_status.isAuthenticated && this.settings.signup_after_purchase
      },
    },
    created() {
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'vouchers/REMOVE_VOUCHER':
          case 'vouchers/ADD_VOUCHER':
          case 'shipping/SET_ACTIVE_SERVICE':
          case 'shipping/SET_DELIVERY_DATE':
            this.getSummary()
            break
          default:
            return false
        }
      })
      this.getSettings()
    },
    methods: {
      ...mapActions('summary', ['getSummary']),
      ...mapActions('settings', [ 'getSettings' ]),
      submit($e) {
        $e.preventDefault()
        if (!this.pendingPurchase) {
          this.$emit('submitForm')
        }
      },
    },
  }
</script>
